import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { CVA_CONSTANTS } from '../../util/constants';
import { HistoricalDataNaviItem } from '../../models/historical-data.interface';
import { CVA_AUTH_MODULES } from '../../models/auth.modules.enum';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  routerObservable: BehaviorSubject<{
    open: boolean;
    props: { route: string };
  }> = new BehaviorSubject<{ open: boolean; props: { route: string } }>({
    open: false,
    props: { route: '/' },
  });

  private readonly historicalDataNavItems$$ = new BehaviorSubject<
    HistoricalDataNaviItem[]
  >([
    {
      title: 'Consultations',
      category: 'Consultations',
      authModule: CVA_AUTH_MODULES.CVA_SOAP_NOTES
    },
    {
      title: 'Observations',
      category: 'Observations',
      authModule: CVA_AUTH_MODULES.CVA_OBSERVATION
    },
    {
      title: 'Allergy',
      category: 'Allergy',
      authModule: CVA_AUTH_MODULES.CVA_ALLERGY
    },
    {
      title: 'Lab Results',
      category: 'Lab Results',
      authModule: CVA_AUTH_MODULES.CVA_LAB_RESULTS,
    },
    {
      title: 'Medication',
      category: 'Medications',
      authModule: CVA_AUTH_MODULES.CVA_MEDICATION_REQUEST,
    },
    {
      title: 'Immunization',
      category: 'immunization',
      authModule: CVA_AUTH_MODULES.CVA_IMMUNIZATION
    }
  ]);

  private readonly isNavExpanded$$ = new BehaviorSubject<boolean>(false);

  private readonly patientId$$ = new BehaviorSubject<string>('');

  private readonly patientMRN$$ = new BehaviorSubject<string>('');

  constructor(private readonly  router: Router) {
    this.subscribeToRouteChange();
  }

  getRouterObservable(): Observable<{
    open: boolean;
    props: { route: string };
  }> {
    return this.routerObservable.asObservable();
  }

  subscribeToRouteChange(): void {
    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.setRouterObservable(event.url);
      });
  }

  setRouterObservable(routerUrl: string): void {
    this.routerObservable.next({
      open: !CVA_CONSTANTS.DISABLE_NAVIGATION.includes(routerUrl),
      props: {
        route: routerUrl,
      },
    });
  }

  get historicalDataNavItems$(): Observable<HistoricalDataNaviItem[]> {
    return this.historicalDataNavItems$$.asObservable();
  }

  get isNavExpanded$(): Observable<boolean> {
    return this.isNavExpanded$$.asObservable();
  }

  toggleNavExpandedStatus() {
    this.isNavExpanded$$.next(!this.isNavExpanded$$.value);
  }

  get patientId$(): Observable<string> {
    return this.patientId$$.asObservable();
  }

  set patientId$(id: string) {
    this.patientId$$.next(id);
  }

  get patientMRN$(): Observable<string> {
    return this.patientMRN$$.asObservable();
  }

  set patientMRN$(id: string) {
    this.patientMRN$$.next(id);
  }
}
